import React from 'react'
import { graphql } from 'gatsby'
import { PrismicPageDataBodyGlitterEffect } from 'src/typings/generated/graphql'
import GlitterEffect from 'src/components/pageLayout/glitterEffect'
import type { GlitterColorScheme } from 'src/components/pageLayout/glitterEffect'

type Props = {
  slice: PrismicPageDataBodyGlitterEffect
}

const COLOR_SCHEMES: GlitterColorScheme[] = ['pink', 'red', 'white']

export const getGlitterColorScheme = (
  value?: string | null
): GlitterColorScheme => {
  const colorScheme = value?.toLowerCase() as GlitterColorScheme

  return COLOR_SCHEMES.includes(colorScheme) ? colorScheme : 'pink'
}

const GlitterEffectSlice = ({ slice }: Props) => (
  <GlitterEffect
    colorScheme={getGlitterColorScheme(slice.primary.color_scheme)}
  />
)

export default GlitterEffectSlice

export const GlitterEffectFragment = graphql`
  fragment PageDataBodyGlitterEffect on PrismicPageDataBodyGlitterEffect {
    id
    slice_type
    primary {
      color_scheme
    }
  }
`
